var map = {
	"./agility.png": 88,
	"./attack.png": 89,
	"./axes.png": 90,
	"./back_panel.png": 47,
	"./boomerangs.png": 91,
	"./buff.png": 92,
	"./characters/eight-on.png": 48,
	"./characters/eight.png": 49,
	"./characters/erik-on.png": 50,
	"./characters/erik.png": 51,
	"./characters/jade-on.png": 52,
	"./characters/jade.png": 53,
	"./characters/luminary-on.png": 54,
	"./characters/luminary.png": 55,
	"./characters/rab-on.png": 56,
	"./characters/rab.png": 57,
	"./characters/serena-on.png": 58,
	"./characters/serena.png": 59,
	"./characters/serena2-on.png": 93,
	"./characters/serena2.png": 94,
	"./characters/sylvando-on.png": 60,
	"./characters/sylvando.png": 61,
	"./characters/veronica-on.png": 62,
	"./characters/veronica.png": 63,
	"./charm.png": 95,
	"./chivalry.png": 96,
	"./claws.png": 97,
	"./debuff.png": 98,
	"./deftness.png": 99,
	"./equipment/axe.png": 100,
	"./equipment/boomerang.png": 101,
	"./equipment/claws.png": 102,
	"./equipment/greatsword.png": 103,
	"./equipment/knive.png": 104,
	"./equipment/shield.png": 105,
	"./equipment/spear.png": 106,
	"./equipment/staff.png": 107,
	"./equipment/sword.png": 108,
	"./equipment/wand.png": 109,
	"./equipment/whip.png": 110,
	"./fraternity.png": 111,
	"./greatswords.png": 112,
	"./guile.png": 113,
	"./harps.png": 114,
	"./hp.png": 115,
	"./knives.png": 116,
	"./luminary.png": 117,
	"./magic-protection.png": 118,
	"./mending.png": 119,
	"./might.png": 120,
	"./mp.png": 121,
	"./passive.png": 122,
	"./placeholder.png": 46,
	"./resilience.png": 123,
	"./restore.png": 124,
	"./shields.png": 125,
	"./spears.png": 126,
	"./staffs.png": 127,
	"./start.png": 128,
	"./strenght.png": 129,
	"./swordmastery.png": 130,
	"./swords.png": 131,
	"./wands.png": 132,
	"./whips.png": 133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;